<template>
  <b-container>
    <b-row>
      <h1>{{ $t("checklist.form.CreateForm") }}</h1>
      <success-fade-alert ref="alert" msg="Formulário criado com sucesso" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <base-error-container :modelstate="modelstate"></base-error-container>

    <b-form-group
      label="Nome do formulário"
      label-for="input-form-name"
      class="mb-4"
    >
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="form.nome"
        required
        placeholder="Insira o nome do formulário"
      ></b-form-input>
      <span class="text-danger" v-if="modelstate['Nome']">
        {{ modelstate["Nome"][0] }}
      </span>
    </b-form-group>

    <h4>Campos do formulário</h4>
    <table-form-fields
      :items="form.campos"
      :allow-add-fields="true"
      :company-options="companyOptions"
      :options-profiles="optionsProfiles"
      :profiles="profiles"
      :userMaster="true"
      class="mb-4"
    ></table-form-fields>

    <b-row>
      <b-col md="6">
        <!-- Search key -->
        <form-search-key
          :form="form"
          :modelstate="modelstate"
        ></form-search-key>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group
          label-for="CanReopenForm"
          :label="$t('checklist.form.canReopenForm')"
          class="mb-4"
        >
          <b-form-select
            id="CanReopenForm"
            :options="optionsBoolean"
            v-model="form.canReopenForm"
          />
          <span class="text-danger" v-if="modelstate['CanReopenForm']">
            {{ modelstate["CanReopenForm"][0] }}
          </span>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group
          label-for="NotifyFill"
          :label="'Agrupar campos na exportação'"
          class="mb-4"
        >
          <b-form-select
            id="CanReopenForm"
            :options="optionsBoolean"
            v-model="form.groupEqualFields"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group
          label-for="NotifyFill"
          :label="'Notificar preenchimento'"
          class="mb-4"
        >
          <pendency-generation-notify-dropdown
            id="NotifyFill"
            class="select-boolean"
            :model.sync="form.notifyFill"
          >
          </pendency-generation-notify-dropdown>
          <span class="text-danger" v-if="modelstate['NotifyFill']">
            {{ modelstate["NotifyFill"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="form.notifyFill">
        <b-form-group
          label-for="NotifyFill"
          :label="'Tipo de anexo'"
          class="mb-4"
        >
          <pdf-attachment-mode
            :isForm="true"
            :model.sync="form.pdfAttachmentMode"
          ></pdf-attachment-mode>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesFill')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesFill"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesFill')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesFill"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesViewer')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesViewer"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesViewer')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesViewer"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.profilesEdit')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="profilesEditor"
            label="displayName"
            track-by="id"
            :placeholder="$t('checklist.form.profilesEdit')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="profiles"
            @input="onChangeProfilesEdit"
          >
          </multiselect>
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group
          :label="$t('checklist.form.pendencyExpirationIntervalType')"
          label-for="PendencyExpirationIntervalType"
          class="mb-4"
        >
          <b-form-select
            id="PendencyExpirationIntervalType"
            :options="optionsIntervalType"
            v-model="form.pendencyExpirationIntervalType"
          ></b-form-select>
          <span
            class="text-danger"
            v-if="modelstate['PendencyExpirationIntervalType']"
          >
            {{ modelstate["PendencyExpirationIntervalType"][0] }}
          </span>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group
          v-if="canShowPendencyExpirationIntervalRange"
          :label="getPendencyExpirationIntervalRangeLabel"
          label-for="PendencyExpirationIntervalRange"
          class="mb-4"
        >
          <base-input-integer
            id="PendencyExpirationIntervalRange"
            placeholder="Insira o range da frequência"
            :value.sync="form.pendencyExpirationIntervalRange"
            :readonly="false"
          >
          </base-input-integer>
          <span
            class="text-danger"
            v-if="modelstate['PendencyExpirationIntervalRange']"
          >
            {{ modelstate["PendencyExpirationIntervalRange"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">
        <b-form-group
          label="Nível de compressão"
          label-for="CompressionLevel"
          v-if="companyHasIntegrations"
        >
          <b-form-input
            id="compressionLevel"
            v-model="form.compressionLevel"
            type="range"
            min="10"
            max="100"
          ></b-form-input>
          <span :style="typeColor()">
            {{ statusQuality() }}
          </span>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <!-- Qualidade da imagem -->
        <b-form-group
          label="Qualidade da imagem"
          label-for="imageQuality"
          v-if="companyHasIntegrations"
        >
          <!-- Qualidade Padrão(480P) -->
          <b-form-checkbox
            id="imageQuality"
            v-model="form.imageQuality"
            :value="0"
            :unchecked-value="1"
          >
            480P
          </b-form-checkbox>
          <!-- Qualidade Alta(1080P) -->
          <b-form-checkbox
            class="mt-3"
            id="imageQuality"
            v-model="form.imageQuality"
            :value="1"
            :unchecked-value="0"
          >
            1080P
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="companyHasIntegrations">
      <b-col md="12">
        <b-form-group
          :label="$t('checklist.form.ScriptPythonProcess')"
          label-for="ScriptPythonProcess"
        >
          <b-row>
            <b-col cols="4">
              <b-form-select
                id="geraAnomalia"
                class="select-boolean"
                :options="optionsScriptProcess"
                v-model="form.predefinedScriptProcess.predefinedScriptId"
                v-if="companyHasIntegrations"
              ></b-form-select>
            </b-col>
          </b-row>
          <div v-if="form.predefinedScriptProcess.predefinedScriptId != 0">
            <predefined-script-form
              :predefinedScriptId.sync="
                form.predefinedScriptProcess.predefinedScriptId
              "
              :script.sync="form.postCalculationScript"
              :fields.sync="form.campos"
              :model.sync="form.predefinedScriptProcess"
            ></predefined-script-form>
          </div>
          <custom-codemirror
            class="mt-4"
            id="ScriptPythonProcess"
            :model.sync="form.scriptPythonProcess"
            :readonly="companyHasIntegrations"
          />
          <span class="text-danger" v-if="modelstate['ScriptPythonProcess']">
            {{ modelstate["ScriptPythonProcess"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="companyHasIntegrations">
      <b-col md="12">
        <b-form-group
          :label="$t('checklist.form.scriptPythonValidatePendencies')"
          label-for="ScriptPythonValidatePendencies"
        >
          <b-row>
            <b-col cols="4">
              <b-form-select
                id="geraAnomalia"
                class="select-boolean"
                :options="optionsScriptValidatePendencies"
                v-model="
                  form.predefinedScriptValidationPendencies.predefinedScriptId
                "
              ></b-form-select>
            </b-col>
          </b-row>
          <div
            v-if="
              form.predefinedScriptValidationPendencies.predefinedScriptId != 0
            "
          >
            <predefined-script-form
              :predefinedScriptId.sync="
                form.predefinedScriptValidationPendencies.predefinedScriptId
              "
              :script.sync="form.scriptPythonValidatePendencies"
              :fields.sync="form.campos"
              :model.sync="form.predefinedScriptValidationPendencies"
            ></predefined-script-form>
          </div>
          <custom-codemirror
            class="mt-4"
            id="ScriptPythonValidatePendencies"
            :model.sync="form.scriptPythonValidatePendencies"
            :readonly="companyHasIntegrations"
          />
          <span
            class="text-danger"
            v-if="modelstate['ScriptPythonValidatePendencies']"
          >
            {{ modelstate["ScriptPythonValidatePendencies"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button class="button" size="sm" @click="saveForm" :disabled="submitted">
      Salvar Formulário
    </b-button>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseErrorContainer from "@/components_rms/base/BaseErrorContainer.vue";
import BaseInputInteger from "@/components_rms/base/BaseInputInteger.vue";
import CopyFields from "@/components_rms/checklist/form/CopyFields";
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";

export default {
  name: "CreateForm",
  components: {
    BaseErrorContainer,
    BaseInputInteger,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    FormSearchKey: () =>
      import("@/components_rms/checklist/form/FormSearchKey.vue"),
    PendencyGenerationNotifyDropdown: () =>
      import(
        "@/components_rms/checklist/pendency/PendencyGenerationNotifyDropdown.vue"
      ),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TableFormFields: () =>
      import("@/components_rms/checklist/form/TableFormFields.vue"),
    PdfAttachmentMode: () =>
      import("@/components_rms/checklist/fill/PdfAttachmentMode.vue"),
    CustomCodemirror,
    PredefinedScriptForm: () =>
      import("@/components_rms/checklist/form/PredefinedScriptForm.vue"),
  },
  mixins: [CopyFields],
  props: {
    id: String,
    idBase: String,
    moduleId: String,
  },
  directives: {
    mask: AwesomeMask,
  },
  data() {
    return {
      alert: {
        error: "",
      },
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      companyOptions: [
        { value: null, text: "Tipo" },
        { value: 1, text: "Lógico" },
        { value: 2, text: "Data" },
        { value: 3, text: "Hora" },
        { value: 4, text: "Decimal" },
        { value: 5, text: "Inteiro" },
        { value: 6, text: "Texto" },
        { value: 7, text: "Lista" },
        { value: 8, text: "Anotação" },
        { value: 10, text: "Apenas Anexos" },
        { value: 11, text: "Assinatura" },
        { value: 13, text: "Objetivo" },
        { value: 14, text: "Responsible" },
        { value: 15, text: "CNPJ" },
        { value: 16, text: "CNPJ Filial" },
        { value: 17, text: "CPF" },
        { value: 20, text: "Veículo" },
        // { value: 12, text: "QRCode Scan" },
      ],
      companyHasIntegrations: false,
      formSearchKey: null,
      formSearchKeyField: null,
      submitted: false,
      sucesso: false,
      modelstate: {},
      form: {
        ativo: true,
        pendencyExpirationIntervalType: 0,
        pendencyExpirationIntervalRange: 0,
        nome: "",
        notifyFill: false,
        pdfAttachmentMode: 0,
        campos: [],
        canReopenForm: false,
        profilesFill: [],
        profilesViewer: [],
        profilesEditor: [],
        scriptPythonProcess: "",
        scriptPythonValidatePendencies: "",
        moduleId: "0",
        groupEqualFields: true,
        predefinedScriptProcess: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
        predefinedScriptValidationPendencies: {
          id: 0,
          predefinedScriptId: 0,
          Variables: [],
        },
        compressionLevel: 40,
        imageQuality: 0,
      },
      optionsProfiles: [],
      optionsIntervalType: [
        { value: 0, text: "Não expira" },
        { value: 1, text: "Hora" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
        { value: 5, text: "Ano" },
      ],
      profiles: [],
      profilesFill: [],
      profilesViewer: [],
      profilesEditor: [],
      optionsScriptProcess: [],
      optionsScriptValidatePendencies: [],
      companyFormOptions: {
        imageQualityEnum: 0,
        imageCompressLevel: 40,
        allowsDocuments: 0,
        allowsVideo: 0,
      },
    };
  },
  created: function () {
    this.loadCompanyOptions();
    this.loadCompanyHasIntegrations();
    this.loadCompanyProfiles();
    this.getScriptDropdown();
    this.loadCompanyFormOptions();
    if (this.idBase) {
      this.loadDataClone();
    }
    this.validateUser();
  },
  computed: {
    canShowPendencyExpirationIntervalRange() {
      if (this.form) {
        if (this.form.pendencyExpirationIntervalType > 0) {
          return true;
        }
      }
      return false;
    },
    getPendencyExpirationIntervalRangeLabel() {
      let text = this.$t("checklist.form.pendencyExpirationIntervalRange");
      if (this.form) {
        switch (this.form.pendencyExpirationIntervalType) {
          case 1:
            return `${text} (Horas)`;
          case 2:
            return `${text} (Dias)`;
          case 3:
            return `${text} (Semanas)`;
          case 4:
            return `${text} (Meses)`;
          case 5:
            return `${text} (Anos)`;
          default:
            return text;
        }
      }
      return text;
    },
  },

  methods: {
    getScriptDropdown() {
      this.$apiChecklist;
      this.$apiChecklist
        .get("/predefinedScript/getAllDropdown/")
        .then((response) => {
          for (let script of response.data) {
            let opt = { value: script.id, text: script.name };
            if (script.scriptType == 4) {
              optionsScriptValidatePendencies.push(opt);
            } else if (script.scriptType == 2) {
              this.optionsScriptProcess.push(opt);
            }
          }
        });
    },
    loadCompanyOptions() {
      this.$apiChecklist
        .get("/systemFieldType/getCompanyTypes/")
        .then((response) => {
          this.companyOptions = response.data;
        });
    },
    loadCompanyHasIntegrations() {
      this.$apiChecklist
        .get("/systemIntegrationCompany/hasIntegrations/")
        .then((response) => {
          this.companyHasIntegrations = response.data.status == 2100;
        });
    },
    loadCompanyProfiles() {
      this.$apiScheduler
        .get("/profile/getCompanyProfiles/")
        .then((response) => {
          this.profiles = response.data.sort((a1, a2) =>
            a1.displayName.localeCompare(a2.displayName)
          );
          this.optionsProfiles = [{ value: null, text: "Selecione o perfil" }];
          this.profiles.forEach((x) => {
            this.optionsProfiles.push({
              value: x.id,
              text: x.displayName,
            });
          });
        });
    },
    validateUser() {
      this.$apiScheduler
        .get("/validateUser/")
        .then((response) => {
          // console.log(this.modules);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$router.push({ path: "home" });
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else if (error.response.status == 404) {
            this.$router.push("/login");
          }
          console.log(error);
          console.log(error.response.data.errors);
          return null;
        });
    },
    async loadDataClone() {
      console.log("LoadClone()");
      this.$apiChecklist
        .get("/form/getdetailed/" + this.idBase.toString())
        .then((response) => {
          // Copy form
          console.log(response);
          let formTemp = response.data.data;
          this.form = {
            canReopenForm: formTemp.canReopenForm,
            pendencyExpirationIntervalType:
              formTemp.pendencyExpirationIntervalType,
            pendencyExpirationIntervalRange:
              formTemp.pendencyExpirationIntervalRange,
            nome: formTemp.nome,
            notifyFill: formTemp.notifyFill,
            profileId: formTemp.profileId,
            scriptPythonProcess: formTemp.scriptPythonProcess,
            ScriptPythonValidatePendencies:
              formTemp.ScriptPythonValidatePendencies,
            predefinedScriptProcess: formTemp.predefinedScriptProcess,
            predefinedScriptValidationPendencies:
              formTemp.predefinedScriptValidationPendencies,
            campos: [],
          };
          this.form.profilesFill = [];
          this.form.profilesViewer = [];
          this.profilesFill = [];
          this.profilesViewer = [];
          this.form.profilesEditor = [];
          this.profilesEditor = [];

          // Copy field in recursive mode
          let fieldsTemp = [];
          formTemp.campos.forEach((campoTemp) => {
            this.copyField(campoTemp, this.form.campos);
          });
        })
        .catch((error) => {
          this.form = {};
          console.log("Excessão");
          console.log(error);
        });
    },
    saveForm() {
      if (this.moduleId) this.form.moduleId = this.moduleId;

      console.log("Create form");
      console.log(this.form);
      this.submitted = true;
      this.$apiChecklist
        .post("/v2/form/Create", this.form)
        .then((response) => {
          console.log(response.data);
          if (response.data.data == null) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.form = {
              ativo: true,
              pendencyExpirationIntervalType: 0,
              pendencyExpirationIntervalRange: 0,
              nome: "",
              scriptPythonProcess: "",
              scriptPythonValidatePendencies: "",
              campos: [],
            };
            this.form.profilesFill = [];
            this.form.profilesViewer = [];
            this.profilesFill = [];
            this.profilesViewer = [];
            this.form.profilesEditor = [];
            this.profilesEditor = [];

            this.$refs.alert.show();
            this.submitted = false;
            this.modelstate = {};
          }
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            } else if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText}`;
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            }
          } else {
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
    onChangeProfilesFill(value) {
      this.profilesFill = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesFill = this.profilesFill;
    },
    onChangeProfilesViewer(value) {
      this.profilesViewer = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesViewer = this.profilesViewer;
    },
    onChangeProfilesEdit(value) {
      this.profilesEditor = value.sort((a1, a2) =>
        a1.displayName.localeCompare(a2.displayName)
      );
      this.form.profilesEditor = this.profilesEditor;
    },
    typeColor() {
      let compressionLevel = this.form.compressionLevel;
      if (this.$store.getters.darkmode == true) {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: lawngreen";
        }
      } else {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: green";
        }
      }
    },
    statusQuality() {
      let compressionLevel = this.form.compressionLevel;
      if (compressionLevel < 40) {
        return `${compressionLevel} Baixa qualidade`;
      } else if (compressionLevel >= 40 && compressionLevel <= 80) {
        return `${compressionLevel} Média Qualidade`;
      } else if (compressionLevel > 80) {
        return `${compressionLevel} Alta qualidade`;
      }
    },
    async loadCompanyFormOptions() {
      this.$apiChecklist
        .get("/form/companyConfiguration")
        .then((response) => {
          this.companyFormOptions = response.data;
          this.form.compressionLevel =
            this.companyFormOptions.imageCompressLevel;
          this.form.imageQuality = this.companyFormOptions.imageQualityEnum;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.button {
  margin-left: -1.3%;
}
</style>
